/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_appsync_graphqlEndpoint": "https://ottbjamnizdelcyirhefrszd7m.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "eu-west-1:32fd76ab-60b7-4404-ba5a-6b77017b2ca5",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_vyRMU2luv",
    "aws_user_pools_web_client_id": "29f3325o5s6a978g1vhf9r9fr3",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "FAMILY_NAME",
        "GIVEN_NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "mytutor-prod-dev",
    "aws_content_delivery_bucket_region": "eu-west-1",
    "aws_content_delivery_url": "https://d3vtw8gcscxpqd.cloudfront.net",
    "aws_user_files_s3_bucket": "mytutor-user-photos73912-dev",
    "aws_user_files_s3_bucket_region": "eu-west-1"
};


export default awsmobile;
